// extracted by mini-css-extract-plugin
export var printerCard = "_ae-1";
export var printerCardConfigured = "_ae-2";
export var printerCardError = "_ae-3";
export var printerCardsContainer = "_ae-0";
export var printerIcon = "_ae-8";
export var printerIconConfigured = "_ae-5";
export var printerIconContainer = "_ae-4";
export var printerIconError = "_ae-6";
export var printerIconUnconfigured = "_ae-7";
export var workstationsTableCard = "_ae-9";